import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
  Avatar,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  IconButton, 
  LinearProgress,
} from '@material-ui/core';


import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import DescriptionIcon from '@material-ui/icons/Description';

import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';

//import { getInitials } from 'helpers';

import { IsNoU } from "common/utils";

// const data = [
//   {'광고대행사': "대행사 1", '광고주명': "광고주 1", '광고명':'광고명 1', '계약금액':10000, '계약카운트': 1000, '재생카운트':1200, '카운트달성일자': '2020-09-22'},
//   {'광고대행사': "대행사 1", '광고주명': "광고주 1", '광고명':'광고명 1', '계약금액':10000, '계약카운트': 1000, '재생카운트':1200, '카운트달성일자': '2020-09-22'},
//   {'광고대행사': "대행사 1", '광고주명': "광고주 1", '광고명':'광고명 1', '계약금액':10000, '계약카운트': 1000, '재생카운트':1200, '카운트달성일자': '2020-09-22'},
//   {'광고대행사': "대행사 1", '광고주명': "광고주 1", '광고명':'광고명 1', '계약금액':10000, '계약카운트': 1000, '재생카운트':1200, '카운트달성일자': '2020-09-22'},
//   {'광고대행사': "대행사 1", '광고주명': "광고주 1", '광고명':'광고명 1', '계약금액':10000, '계약카운트': 1000, '재생카운트':1200, '카운트달성일자': '2020-09-22'},
// ];

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  rowIcons: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    //paddingLeft: theme.spacing(8),
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const SettlementTable = props => {
  const { 
    className, 
    onClickExportExcel,
    user_role,
    type,
    items,
    onSetSelectedItems,
    userName,
    
    openProgress,
    page,
    rowsPerPage,
    item_total,
    onPageChange,
    onRowsPerPageChange,

    ...rest 
  } = props;

  const classes = useStyles();

  const [selectedItems, setSelectedItems] = useState([]);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [page, setPage] = useState(0);


  const handleSelectAll = event => {

    let selectedItems;

    if (event.target.checked) {
      selectedItems = items.map(item => item.id);
    } else {
      selectedItems = [];
    }

    setSelectedItems(selectedItems);
    onSetSelectedItems(selectedItems);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedItems.indexOf(id);
    let newSelectedItems = [];

    if (selectedIndex === -1) {
      newSelectedItems = newSelectedItems.concat(selectedItems, id);
    } else if (selectedIndex === 0) {
      newSelectedItems = newSelectedItems.concat(selectedItems.slice(1));
    } else if (selectedIndex === selectedItems.length - 1) {
      newSelectedItems = newSelectedItems.concat(selectedItems.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedItems = newSelectedItems.concat(
        selectedItems.slice(0, selectedIndex),
        selectedItems.slice(selectedIndex + 1)
      );
    }

    setSelectedItems(newSelectedItems);
    onSetSelectedItems(newSelectedItems);
  };

  // const handlePageChange = (event, page) => {
  //   setPage(page);
  // };

  // const handleRowsPerPageChange = event => {
  //   setRowsPerPage(event.target.value);
  // };

  // useEffect(() => {
  //   //console.log('componentDidUpdate & type changed');

  // }, [type]);

  // useEffect(() => {
  //   //console.log('componentDidUpdate & companies changed');

  // }, [items]);

  return (
    <div>

      <div className={classes.rowIcons}>
        <IconButton 
          onClick = { onClickExportExcel }
          //disabled={}
        >
            <CloudDownloadIcon />
        </IconButton>
{/* 
        <IconButton>
            <DescriptionIcon />
        </IconButton> */}
      </div>
      
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          {openProgress && <LinearProgress /> }
          <Table>
            <TableHead>
              <TableRow>
              <TableCell padding="checkbox">
                  <Checkbox
                    checked={items.length > 0 && selectedItems.length === items.length}
                    color="primary"
                    indeterminate={
                      selectedItems.length > 0 &&
                      selectedItems.length < items.length
                    }
                    onChange={handleSelectAll}
                  />
                </TableCell>
                { user_role !== 'client' && <TableCell>광고대행사명</TableCell> }
                <TableCell>광고주명</TableCell>
                <TableCell>광고명</TableCell>
                {/* <TableCell>계약금액</TableCell> */}
                {/* <TableCell>계약카운트</TableCell> */}
                <TableCell>재생횟수</TableCell>
                {/* <TableCell>카운트달성일자</TableCell> */}
                <TableCell>시작일자</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.slice(0, rowsPerPage).map((item, index) => (
                <TableRow
                  className={classes.tableRow}
                  hover
                  key={item.id}
                  selected={selectedItems.indexOf(item.id) !== -1}
                >
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedItems.indexOf(item.id) !== -1}
                      color="primary"
                      onChange={event => handleSelectOne(event, item.id)}
                      value="true"
                    />
                  </TableCell>
                  { user_role !== 'client' && ( <TableCell>
                    <div className={classes.nameContainer}>
                      <Typography variant="body1">{item.agency}</Typography>
                    </div>
                  </TableCell> )}
                  <TableCell>{item.client}</TableCell>
                  <TableCell>{item.name}</TableCell>
                  {/* <TableCell align='right'>{item.cost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+'원'}</TableCell> */}
                  {/* <TableCell align='right'>{item.view_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+'회'}</TableCell> */}
                  {/* <TableCell align='right'>{!IsNoU(item.play_count) && item.play_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+'회'}</TableCell> */}
                  <TableCell>{!IsNoU(item.play_count) && item.play_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+'회'}</TableCell>
                  {/* <TableCell>{!IsNoU(item.complated_at) && moment(item.complated_at).format('YYYY-MM-DD')}</TableCell> */}
                  <TableCell>{!IsNoU(item.start_date) && moment(item.start_date).format('YYYY-MM-DD')}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={classes.actions}>
        <TablePagination
          labelRowsPerPage=''
          component="div"
          count={item_total}
          onChangePage={onPageChange}
          onChangeRowsPerPage={onRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </CardActions>
    </Card>

    </div>
  );
};

SettlementTable.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  items: PropTypes.array.isRequired,
  onSetSelectedItems: PropTypes.func,
};

SettlementTable.defaultProps = {
  items: []
};

export default SettlementTable;
